import { GetCachedGoals } from '../GetCachedGoals';

export const Is1TimeGoal = (entryText: string, isFullEntryText: boolean = false): boolean => {
	const goals = GetCachedGoals();

	if (!goals) {
		return false;
	}

	const entryTextSplit = entryText.split(' ');
	const goalName: string = isFullEntryText ? entryTextSplit[2] : entryTextSplit[0];
	const matchingGoals = goals.filter((goal) => goal.name === goalName);

	if (!matchingGoals.length) {
		return false;
	}

	const isOnlyOneMatchingGoal = matchingGoals.length === 1;
	const is1TimeGoal = matchingGoals[0].is1time;
	return isOnlyOneMatchingGoal && is1TimeGoal;
};
